import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { jwtDecode }  from 'jwt-decode';

import AdminApp from './AdminApp/AdminApp';
import App from './App/App';
import { AuthContext } from '../Data/AuthContext';
import { setAuthorizationHeader } from '../Utils/AuthenticationHandler';
import { TOKEN_NAME, TOKEN_SUB, TOKEN_ROLES, TOKEN_EMAIL, TOKEN_IS_FRESHMAN } from '../Data/Constants';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './Root.css';

class Root extends Component {
    constructor(props) {
        super(props);

        this.login = (token) => {
            setAuthorizationHeader(token);
            let tokenDecoded = jwtDecode(token);
            this.setState({
                name: tokenDecoded[TOKEN_NAME],
                userId: tokenDecoded[TOKEN_SUB],
                email: tokenDecoded[TOKEN_EMAIL],
                roles: tokenDecoded[TOKEN_ROLES],
                isFreshman: tokenDecoded[TOKEN_IS_FRESHMAN] === "True" ? true : false,
                jwtToken: token,
                isAuthenticated: true
            });
            localStorage.setItem('token', token);
        };

        this.logout = () => {
            setAuthorizationHeader(null);
            this.setState({
                name: '',
                email: '',
                roles: [],
                isFreshman: false,
                jwtToken: '',
                isAuthenticated: false
            });
            localStorage.clear('token');
        };

        this.state = {
            name: '',
            jwtToken: '',
            roles: [],
            isAuthenticated: false,
            login: this.login,
            logout: this.logout
        };
    }

    componentDidMount() {
        let token = localStorage.getItem('token');
        if (token) {
            let tokenDecoded = jwtDecode(token);

            if (new Date(tokenDecoded.exp * 1000) > new Date()) {
                this.state.login(token);
            } else
                localStorage.removeItem("token");
        }
    }

    render() {
        return (
            <AuthContext.Provider value={this.state}>
                <Router>
                    <Routes>
                        <Route path='/admin/*' element={<AdminApp />} />
                        <Route path='/*' element={<App />} />
                    </Routes>
                    <ToastContainer theme="colored" position="bottom-center" pauseOnHover={false} draggable={false} />
                </Router>
            </AuthContext.Provider>
        );
    }
}

export default Root;